import axios from "axios";

export default function PurchaseorderRequestToOrderService(orderId) {
  return axios({
    method: 'post',
    url: process.env.REACT_APP_API_HOST + "/purchase_order/request_to_order",
    data: {
      purchaseOrderRequest: orderId
    },
    params: {},
    headers: {'Authorization': 'Bearer ' + localStorage.getItem("userToken"), 'App-Network': localStorage.getItem("networkId")}
  });
}
